import moment from 'moment'

export default function(val) {
    return val != null ? val.substring(0,5) : null
}; 